import React, { useState } from 'react';
import { FiInfo } from 'react-icons/fi';
import { X } from 'lucide-react';

const SECURITY_FEE_TEXT =
  "Declare parcel value (up to ₹30,000). A 1% protection fee applies. In verified cases of loss or damage, compensation is provided up to the declared value, subject to terms & conditions.";

const SecurityFeeInfoButton = ({
  iconClassName = 'text-gray-500 text-sm',
  title = 'Security Charges',
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen(true);
        }}
        className="inline-flex items-center justify-center"
        aria-label="Security charges information"
      >
        <FiInfo className={iconClassName} />
      </button>

      {open && (
        <div className="fixed inset-0 z-[6000] flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-md rounded-2xl border-2 border-accentYellow bg-white p-5 shadow-2xl">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="text-lg font-bold text-gray-900">{title}</h3>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="rounded-md bg-gray-50 p-1 text-gray-600 hover:bg-gray-100"
                aria-label="Close security charges popup"
              >
                <X size={18} />
              </button>
            </div>
            <p className="text-sm leading-6 text-gray-700">{SECURITY_FEE_TEXT}</p>
            <div className="mt-5 flex justify-end">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="rounded-xl bg-accentYellow px-4 py-2 font-semibold text-white hover:bg-accentYellow/90"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SecurityFeeInfoButton;
